//全局使用的一些函数
import _Vue from "../../main";
import router from '../../router'
import moment from 'moment'
export default {
  install(Vue) {

    //================ 用户校验相关

    //根据sessionKey获取用户信息 全局函数
    Vue.prototype.getUserInfo = function (userinfosessionKey, redirect) {
      const _Vue = this;

      var redirect = decodeURIComponent(redirect);

      _Vue.axios.post(_Vue.$store.state.api.common + 'index_api/get_userinfo_by_token', _Vue.qs.stringify({
        token: userinfosessionKey
      })).then(function (res) {

        // console.log(res);
        
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
              location.href = tmpUrl;
              // _Vue.$router.replace({ path: '/login', query: { redirect: redirect } });
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 1) {
            const fetch_data = res.data.data;
            //console.log(fetch_data);
            let user_data = {
              sessionkey: fetch_data.token,

              id: fetch_data.id,
              username: fetch_data.username,
              nickname: fetch_data.nickname ? fetch_data.nickname : '无昵称',
              name: fetch_data.realname,
              avatar: fetch_data.avatar,
              role_code: fetch_data.role_code,
              role_type: fetch_data.role_type,
              role_name:fetch_data.role_type == 'storeManager'?'store':fetch_data.role_type,
              sbuCode: fetch_data.sbuCode,
              service_shopno:  fetch_data.service_shopno,
              store_shopno: fetch_data.store_shopno,
              store_storename:  fetch_data.store_storename,
              service_shopno: fetch_data.service_shopno,//服务门店
              dealer_dealerCode: fetch_data.dealer_dealerCode,
              dealer_dealername:  fetch_data.dealer_dealername,

              //sbucode: fetch_data._user.bindSbuCode,
              //dealercode: fetch_data._user.bindDealerCode,
              //shopno: fetch_data._user.bindShopNo,
              //roletype: 1,//经销商
            }

            // if( user_data.shopno ){
            //   user_data.roletype = 0;//门店
            // }

            // fetch_data._auth.forEach(function(item_goods){
            //     if(item_goods.role_code == "master"){
            //       user_data.roletype = 2;//总部
            //     }
            // });

            //本地存储
            localStorage.setItem('giant_insure_userdata', JSON.stringify(user_data));//session
            //sessionStorage.setItem('user_','#/IndexA');

            //读取
            //console.log( localStorage.getItem('user_data') );
            //console.log( JSON.parse(localStorage.getItem('user_data')) );

            //_Vue.$router.replace({ path: '/'});
            console.log(redirect);
            //return false;
            if (redirect) {

              location.replace(redirect);
              // if (redirect != './') {
              //   location.reload();
              // }
            }

            //console.error(res.data.msg ? res.data.msg : '自动登录失败');
            //_Vue.$router.replace({ path: '/login', query: { redirect: redirect } });
            // _Vue.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: '登录失效',
            //   message: '出现了一些问题',
            //   showCancelButton: false,
            //   confirmButtonText: '前往opo登录',
            // }).then(() => {
            //   location.replace(_Vue.$store.state.externalurl.opo);
            // }).catch(() => {
            // });
          }else{
            _Vue.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: res.data.msg,
              message: '请重新登录',
              confirmButtonText: '重新登录',
              showCancelButton: true,
              cancelButtonText:"返回"
            }).then(() => {
              let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
              location.href = tmpUrl;
            }).catch(() => {
              history.back()
            });
          }

        } else {
          console.error('自动登录失败——2');
          let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
          location.href = tmpUrl;
          // _Vue.$router.replace({ path: '/login', query: { redirect: redirect } });
          // _Vue.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '请求用户失败',
          //   message: '出现了一些问题',
          //   showCancelButton: false,
          //   confirmButtonText: '前往opo登录',
          // }).then(() => {
          //   location.replace(_Vue.$store.state.externalurl.opo);
          // }).catch(() => {
          // });
        }

      }).catch(function (error) {
        let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
        location.href = tmpUrl;
        // _Vue.$router.replace({ path: '/login', query: { redirect: redirect } });
        // _Vue.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '获取用户信息出错',
        //   message: '出现了一些问题',
        //   showCancelButton: false,
        //   confirmButtonText: '前往opo登录',
        // }).then(() => {
        //   location.replace(_Vue.$store.state.externalurl.opo);
        // }).catch(() => {
        // });
        console.error(error);
      });
    }

    //刷新sessionKey（token） 全局函数
    //callback 成功，sorryFn 失败
    Vue.prototype.refreshToken = function (callback, sorryFn) {
      // const _Vue = this;

      // console.log(_Vue.GLOBAL.pageApiUrl + '/user/checkUserInfo')
      // console.log(userinfosessionKey)
      //如果在App环境中，调用App的刷新Token方法
      if( _Vue.checkGiantAppVersion('2.3.4', true) ){
        if( _Vue.$store.state.browser.ios ){
          JSBridge.reload.postMessage("");
        } else {
          android.reload();
        }
        return false;
      }

      _Vue.axios.post(_Vue.$store.state.api.common + 'index_api/refresh_token', _Vue.qs.stringify({
        token: _Vue.$store.state.loginUser.sessionkey
      })).then(function (res) {

        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              console.error(error);
              if (sorryFn) {
                if (typeof sorryFn == "function") {
                  sorryFn();
                } else {
                  _Vue.$dialog.confirm({
                    closeOnPopstate: true,//页面回退时自动关闭
                    title: res.data.msg,
                    message: '您可以尝试：',
                    confirmButtonText: '重新登录',
                    cancelButtonText: '刷新重试'
                  }).then(() => {
                    let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
                    location.href = tmpUrl;
                    // _Vue.$router.replace({ path: '/login', query: { redirect: location.href } });
                  }).catch(() => {
                    location.reload(true);
                  });
                }
              }
              return false;
            }
          }
          if (res.data.status == 1) {

            let user_data = JSON.parse(localStorage.getItem('giant_insure_userdata'));
            user_data.sessionkey = res.data.data;
            //本地存储
            localStorage.setItem('giant_insure_userdata', JSON.stringify(user_data));//session

            _Vue.$store.commit('updateLoginUser', user_data);

            //const fetch_data = res.data.data;
            //console.log(fetch_data);
            if (typeof callback == "function") {
              setTimeout(function () {
                callback();
              }, Math.ceil(Math.random() * 500));//增加<500毫秒的延时
            }

          } else if (res.data.status == 3) {//token有误，已无效
            //_Vue.$router.replace({ path: '/login', query: { redirect: _Vue.$route.fullPath } });
            // _Vue.$router.replace({ path: '/login', query: { redirect: location.href } });
            let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
            location.href = tmpUrl;
            return false;
            //_Vue.$toast(res.data.msg);
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _Vue.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg,
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  _Vue.$router.replace({ path: '/login', query: { redirect: location.href} });
                }).catch(() => {
                  history.back();
                });
              }
            }
          } else {
            //_Vue.$toast('更新令牌出现了一些问题');
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                console.log(12222)
                _Vue.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg ? res.data.msg : '更新令牌出现了一些问题',
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
                  location.href = tmpUrl;
                  // _Vue.$router.replace({ path: '/login', query: { redirect: location.href } });
                }).catch(() => {
                  history.back();
                });
              }
            }
          }

        } else {
          //_Vue.$toast('请求更新令牌失败');
          if (sorryFn) {
            if (typeof sorryFn == "function") {
              sorryFn();
            } else {
              _Vue.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '请求更新令牌失败',
                message: '您可以尝试：',
                confirmButtonText: '重新登录',
                cancelButtonText: '返回上一页'
              }).then(() => {
                // _Vue.$router.replace({ path: '/login', query: { redirect: location.href } });
                let tmpUrl = _Vue.$store.state.externalurl.officialwebsite_usercenter + '/login/index?return_source=14&return_url=' + (_Vue.$route.query.redirect ? encodeURIComponent(_Vue.$route.query.redirect) : encodeURIComponent(_Vue.$store.state.siteUrl));
                location.href = tmpUrl;
              }).catch(() => {
                history.back();
              });
            }
          }
        }

      }).catch(function (error) {
        console.error(error);
        if (sorryFn) {
          if (typeof sorryFn == "function") {
            sorryFn();
          } else {
            _Vue.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '更新令牌出现异常',
              message: '您可以尝试：',
              confirmButtonText: '重新登录',
              cancelButtonText: '返回上一页'
            }).then(() => {
              _Vue.$router.replace({ path: '/login', query: { redirect: location.href } });
            }).catch(() => {
              history.back();
            });
          }
        }
      });
    };

    //================ 工具相关

    //返回上一页
    Vue.prototype.backToPrevpage = function () {
      const _Vue = this;
      router.go(-1);
    };
    // 关闭骑行app
    Vue.prototype.closeGiantApp = function (){
      const _this = this;
      if (_this.$store.state.browser.giantapp) {
        if (_this.$store.state.browser.ios) {
            window.webkit.messageHandlers.closeWebView.postMessage('');
        } else {
            android.closeWebView();
        }
      } else {
        _this.$router.go(-1);
      } 
    },
    //判断骑行App版本 atleast 至少
    Vue.prototype.checkGiantAppVersion = function (limit_giantappversion, atleast){
      
      let matches = window.navigator.userAgent.toLowerCase().match(/_giantapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if( matches ){
        let limit_var = limit_giantappversion.split('.');
        if( atleast ){
          if( Number(matches[1]) > Number(limit_var[0]) ){
            return true;
          } else if( Number(matches[1]) == Number(limit_var[0]) ){
            if( Number(matches[2]) > Number(limit_var[1]) ){
              return true;
            } else if( Number(matches[2]) == Number(limit_var[1]) ){
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if( Number(limit_var[0]) > Number(matches[1]) ){
            return true;
          } else if( Number(limit_var[0]) == Number(matches[1]) ){
            if( Number(limit_var[1]) > Number(matches[2]) ){
              return true;
            } else if( Number(limit_var[1]) == Number(matches[2]) ){
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content) {
      const _Vue = this;
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
    };

    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false) {
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if (linear) {
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step(newTimestamp) {
          if (firstTimestamp === null) {
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step(newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2) {
      function Rad(d) {
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };

    //获取用户当前位置（定位）
    Vue.prototype.getUserPostion = function (mustReFresh = false, fnCallback, fnError){
      const _this = this;

      if( !mustReFresh ){//非强制刷新
        let tmpUserpostion = JSON.parse(localStorage.getItem('giant_userpostion'));
        if( tmpUserpostion && tmpUserpostion.lat ){
          fnCallback && fnCallback(tmpUserpostion);
        } else {
          _this.getUserPostion( true, fnCallback, fnError );
        }
        return false;
      }

      window.onGaodeLoad = function(){
        _this.getUserPostion( mustReFresh, fnCallback, fnError );
      }
      if( typeof(AMap) =="undefined" ){
        var url = 'https://webapi.amap.com/maps?v=2.0&key=d94102a2b4b53d8d81de63aec201ae4a&callback=onGaodeLoad';
        window._AMapSecurityConfig = {securityJsCode:'700cad2571c2bb840381f9822e0c6a9f'}
        var jsapi = document.createElement('script');
        jsapi.charset = 'utf-8';
        jsapi.src = url;
        document.head.appendChild(jsapi);
      } else {
        let map, geolocation;
        map = new AMap.Map(document.createElement('div'), {
          //resizeEnable: true
        });
        
        map.plugin(['AMap.Geolocation', 'AMap.CitySearch'], function() {
          geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
          });
          if( _this.$store.state.browser.m ){
            geolocation.getCurrentPosition(function(status, result){
              if(status=='complete'){
                //console.log(result.position);
  
                let userpostion_data = {
                  lat: result.position.getLat(),//高精 //result.position.lat
                  lng: result.position.getLng(),//高精 //result.position.lng
                }
                //console.log(userpostion_data);
  
                //本地存储
                localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session
  
                fnCallback && fnCallback(userpostion_data);
  
              } else {
                //onError(result)
                //alert(2);
                fnError && fnError(result);
              }
            });
          }else{
            geolocation.getCityInfo(function(status, result) {
                if (status == 'complete') {
                  let userpostion_data = {
                    lat: result.position[1],
                    lng: result.position[0],//高精 //result.position.lng
                  }
                  //本地存储
                  localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session
    
                  fnCallback && fnCallback(userpostion_data);

                }else{
                  fnError && fnError(result);
                }
            }, {
                enableHighAccuracy: true
            });
          }
          
        });

      }


    };

    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function (num, fixed = 2, round = true, thousand = false) {
      if (isNaN(num)) {
        return num;
      }
      if (fixed >= 0) {
        if (round) {
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if (thousand) {
        var numarr = num.split(".");
        if (numarr.length) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if (numarr.length > 1 && numarr[1] != "") {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };

    //计算 解决js运算bug
    Vue.prototype.mathcalc = function (a, b, mode = '+') {
      const _Vue = this;
      if (mode == '-') {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_Vue.mathcalc(a, e, '*') - _Vue.mathcalc(b, e, '*')) / e;
      } else if (mode == '*') {//=========================
        let c = 0,
          d = a.toString(),
          e = b.toString();
        try {
          c += d.split('.')[1].length;
        } catch (f) { }
        try {
          c += e.split('.')[1].length;
        } catch (f) { }
        return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
      } else if (mode == '/') {//=========================
        let c, d, e = 0, f = 0;
        try {
          e = a.toString().split('.')[1].length;
        } catch (g) { }
        try {
          f = b.toString().split('.')[1].length;
        } catch (g) { }
        return c = Number(a.toString().replace('.', '')), d = Number(b.toString().replace('.', '')), _Vue.mathcalc(c / d, Math.pow(10, f - e), '*');
      } else {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_Vue.mathcalc(a, e, '*') + _Vue.mathcalc(b, e, '*')) / e;
      }
    };

    //格式化时间 时间戳、Date 都行
    Vue.prototype.dateformat = function (dataStr, pattern = 'YYYY/MM/DD HH:mm:ss') {
      if (dataStr.toString().length < 13) {
        dataStr *= 1000;
      }
      return moment(parseInt(dataStr)).format(pattern);
    };

    //时间补0
    Vue.prototype.add0 = function (time) {
      if(time<10){
        time = ""+"0"+time;
      }
      return time;
    };
    //标准时间转时间格式
    Vue.prototype.newTimestamp = function(standardtime){
      standardtime = standardtime.getFullYear() +
      "-" +
      this.add0((Number(standardtime.getMonth()) + 1)) +
      "-" +
      this.add0(standardtime.getDate()) +
      " " +
      this.add0(standardtime.getHours()) +
      ":" +
      this.add0(standardtime.getMinutes()) +
      ":" +
      this.add0(standardtime.getSeconds());

      return standardtime
    }
    //================ 业务相关

    //拉取门店数据
    //funCallback 成功回调 funError 出错回调 funConflict 服务门店有冲突 funClosedown 关店
    Vue.prototype.getStoreData = function (shopno, token, funCallback, funError, funConflict, funClosedown) {
      const _Vue = this;

      //拉取门店信息
      let tmpParams = {
        code: shopno,
        user_id: token,
      };

      _Vue.axios.post(_Vue.$store.state.api.common + 'api/store_detail', _Vue.qs.stringify(tmpParams)).then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _Vue.$toast('拉取门店数据情况未知：接口异常');
              console.error(error);
              return false;
            }
          }
          if (res.data.status == 1) {

            let fetch_data = res.data.data;

            if (!shopno && token) {
              //服务门店与暂存登录信息不符，服务门店已在别处修改过
              if (fetch_data.code != _Vue.$store.state.loginUser.service_shopno) {

                let loginuser_data = JSON.parse(localStorage.getItem('giant_insure_userdata'));
                loginuser_data.service_shopno = fetch_data.code;
                localStorage.setItem('giant_insure_userdata', JSON.stringify(loginuser_data));
                _Vue.$store.commit('updateLoginUser', loginuser_data);

                funConflict && funConflict();//处理冲突
              }
            }

            funCallback && funCallback(fetch_data);

          } else if (res.data.status == 2) {
            _Vue.refreshToken(function () {
              _Vue.getStoreData(shopno, token, funCallback, funError, funConflict, funClosedown);
            }, true);
          } else if (res.data.status == 3) {
            funClosedown && funClosedown(res.data.data ? res.data.data : '【未知门店】');
          } else {
            if (funError) {
              funError();
            } else {
              _Vue.$dialog.confirm({
                title: res.data.msg ? res.data.msg : '出现了一些问题',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: '返回首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                _Vue.$router.replace({ path: '/' });
              });
            }
          }
        } else {
          if (funError) {
            funError();
          } else {
            _Vue.$dialog.confirm({
              title: '商品详情拉取失败',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _Vue.$router.replace({ path: '/' });
            });
          }
        }
      }).catch(function (error) {
        console.error(error);
        if (funError) {
          funError();
        } else {
          _Vue.$dialog.confirm({
            title: '详情拉取失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: '返回首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            _Vue.$router.replace({ path: '/' });
          });
        }


      });

    };



  }
}







// WEBPACK FOOTER //
// ./src/assets/js/site.js